import { navigate } from 'gatsby';

export const removePageQueryParams = (param: string | string[]) => {
    const url = new URL(window.location.href);
    const paramsToDelete = Array.isArray(param) ? param : [param];
    paramsToDelete.forEach(p => url.searchParams.delete(p));
    navigate(url.search, { replace: true });
};
